import { getDateRanges } from '@bingads-webui/date-ranges';
import { getStateDateRangePreset } from './date-range-preset';
import { getSelectionDateParser } from './selection-date';

export default function getStateDateRange({
  today,
  i18n,
  DateRange,
}) {
  const parser = getSelectionDateParser(i18n);

  return getDateRanges({
    today,
    i18n,
    customStart: parser(DateRange.StartDate),
    customEnd: parser(DateRange.EndDate),
  })[getStateDateRangePreset(DateRange.DateRangePreset)];
}
